export default "<span class=\"percent-change\" [ngClass]=\"checkPercent()\" [innerHtml]=\"getArrow()\"></span>\n";